/**
 * Checks if an error is an AbortError from a cancelled fetch operation
 * This specifically checks for Firebase and browser abort errors
 * @param error The error to check
 * @returns true if the error is an AbortError, false otherwise
 */
export const isAbortError = (error: any): boolean => {
  // Check for standard AbortError
  if (error?.name === "AbortError") {
    return true
  }

  // Check for specific Firebase abort error message
  if (error?.message === "Fetch is aborted") {
    return true
  }

  // Check for other abort-related Firebase errors
  const message = error?.message?.toLowerCase() || ""
  return (
    message.includes("operation was aborted") ||
    message.includes("request aborted") ||
    message.includes("fetch aborted")
  )
}
